import { ApiClient, TranslationProvider } from "wonder-image";

window.ApiClient = ApiClient;
window.TranslationProvider = TranslationProvider;

window.API_CLIENT = new ApiClient(pathSite+'/api', API_TOKEN);
window.API_CLIENT_APP = new ApiClient(pathApp+'/api', API_TOKEN);

window.__t = function(key, replacements = []) {
    return TranslationProvider.get(key, replacements);
}